<template>
  <div class="editor-main" :class="getThemeInfo">
    <div class="editor-main-l" :class="getThemeInfo">
      <div class="editor-operation">
        <editorOperation></editorOperation>
      </div>
      <div class="editor-content">
        <editorContent></editorContent>
      </div>
      <div class="editor-pagetion">
        <div class="page-item">
          <span> 当前页数</span>
          <i class="el-icon-arrow-left"></i>
          <span>{{getTaskContentListParams.startSort}} /
            {{getTaskContentList.totalPage}}</span>
          <i class="el-icon-arrow-right"></i>
          <el-input v-model.number="page" size="small" @change="changegoPage">
          </el-input>
          <el-button type="info" size="mini" @click="gotopage">
            跳
          </el-button>
        </div>
        <div class="page-btn">
          <el-button type="primary" size="mini" v-show="getTaskContentListParams.startSort > 1"
                     @click="handlerPrev">
            上一页
          </el-button>
          <el-button type="primary" size="mini" @click="handlerNext"
                     v-show="!(getTaskContentListParams.startSort >= (getTaskContentList.totalPage))">
            下一页</el-button>
        </div>
      </div>
    </div>
    <div class="editor-main-r" :class="getThemeInfo">
      <div class="content">
        <editorRight></editorRight>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import editorOperation from "../../editor/editor-operation/index";
import editorContent from "../editor-main/modules/editor/index";
import editorRight from "../editor-main/modules/editorRight/index"
export default {
  name: "editor-main",
  data() {
    return {
      page: 1,
      totalPage: null,
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',
      'getThemeInfo',                // 主题信息
      'getTaskContentListParams', //获取翻译详情请求数据参数
      'getTaskContentList',//获取翻译详情数据
    ]),
  },
  components: {
    editorOperation,
    editorContent,
    editorRight
  },
  watch: {
    getTaskContentListParams: {
      handler(value) {
        if (value.isfilter) {
          this.page = 1;
        }
      },
      deep: true
    },
  },
  methods: {
    //跳转当前页
    gotopage() {
      this.changegoPage();
    },
    //change跳转
    changegoPage() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if ((!!this.getTaskContentList.totalPage)) {
        this.totalPage = this.getTaskContentList.totalPage
      }
      if (this.page > this.totalPage) {
        this.page = this.totalPage;
      } else if (this.page < 1) {
        this.page = 1;
      } else if (typeof (this.page) !== 'number') {
        this.page = 1;
      }
      const { type } = this.getUrlInfo
      param.startSort = this.page
      param.urltype = type;
      this.$store.dispatch('editor/continueLoadContent', param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      })
    },
    //上一页句子
    handlerPrev() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if ((!!this.getTaskContentList.totalPage)) {
        this.totalPage = this.getTaskContentList.totalPage
      }
      if (param.startSort === 1) {
        this.$message.closeAll();
        this.$message.warning("当前已在第一页");
        return;
      }
      const { type } = this.getUrlInfo
      param.startSort--;
      this.page = param.startSort;
      param.urltype = type;
      this.$store.dispatch('editor/continueLoadContent', param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      })
    },
    //下一页句子
    handlerNext() {
      let param = this.$store.getters["editor/getTaskContentListParams"];
      if ((!!this.getTaskContentList.totalPage)) {
        this.totalPage = this.getTaskContentList.totalPage
      }
      if (param.startSort === this.totalPage) {
        this.$message.closeAll();
        this.$message.warning("当前已在最后一页");
        return;
      }
      const { type } = this.getUrlInfo
      param.startSort++;
      this.page = param.startSort;
      param.urltype = type;
      this.$store.dispatch('editor/continueLoadContent', param);
      this.$nextTick(() => {
        document.getElementById("editorBox").scrollTop = 0;
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>